/**
 * Returns true if we're viewing a "parent" group.
 *
 * @returns boolean
 */
export const displayingParentGroup = (): boolean =>
  (location?.href ?? "").includes("groups-manager/subgroups");
